





























































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Choices from '@/components/Profil/Choices.vue'
import Pieces from '@/components/Profil/Pieces.vue'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getOperation, getOperationID } from '@/api/operations'
import Alert from '@/components/Alert.vue'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { formatLargeNumber } from '@/utils/formatLargeNumber'
import Project from '@/views/profile/Project.vue'
import router from '@/router'
import { getBasePrice } from '@/utils/basePrice'

enum ISize {
    XS = 'xs',
    S = 's',
    M = 'm',
    L = 'l',
    XL = 'xl',
}

interface IRoom {
    room: number
    size: ISize
    quantity: number
    options: string[]
}

interface IAppart {
    wishedSurface: number
    maxFund: number
    wishedParking: number | null
    wishedParkingBoxed: boolean
    eligibleBRS: boolean
    typologieBRS: string | null
    comment: string
    commentKitchen: string
    commentBathroom: string
    wishedOutdoorFloor: null | 'Aucun' | number
    wishedOutdoorGround: null | 'Aucun' | number
    wishedOutdoorSurfaces: number[] // surfaces sélectionnées
    wishedFloors: {
        ground: boolean
        r1: boolean
        soho: boolean
        intermediate: boolean
        intermediateSupp: boolean
        top: boolean
        house: boolean
    }
    wishedExposures: {
        north: boolean
        east: boolean
        west: boolean
        south: boolean
    }
    userOperationRooms: IRoom[]
}

@Component({
    components: {
        Choices,
        Pieces,
        Alert,
        SmoothReflow,
        Project,
    },
    filters: {
        formatLargeNumber,
    },
})
export default class Appartment extends Vue {
    apiService = new ApiService()

    submitted: boolean = false

    filteredFloorItems = null  // Sera initialisé dans created()

    appart: IAppart = {
        wishedSurface: null,
        maxFund: 0,
        wishedParking: null,
        wishedParkingBoxed: false,
        eligibleBRS: false,
        typologieBRS: null,
        comment: '',
        commentKitchen: '',
        commentBathroom: '',
        wishedOutdoorFloor: null,
        wishedOutdoorGround: null,
        wishedOutdoorSurfaces: [], // tableau des surfaces sélectionnées
        wishedFloors: {
            ground: false,
            r1: false,
            soho: false,
            intermediate: false,
            intermediateSupp: false,
            top: false,
            house: false,
        },
        userOperationRooms: [],
        wishedExposures: {
            north: false,
            east: false,
            west: false,
            south: false,
        },
    }
    // Watcher sur les items outdoor pour mettre à jour automatiquement wishedOutdoorSurfaces
    @Watch('outdoor.items', { deep: true })
    onOutdoorItemsChange() {
        const selected = this.outdoor.items.filter(item => item.active && item.surface)
        this.appart.wishedOutdoorSurfaces = selected.map(item => item.surface)
        
        // Mettre à jour aussi wishedOutdoorFloor et wishedOutdoorGround pour compatibilité
        if (selected.length > 0) {
            this.appart.wishedOutdoorFloor = selected[0].surface
            this.appart.wishedOutdoorGround = selected[0].surface
        } else if (this.outdoor.items[0].active) {
            // Cas "Aucun"
            this.appart.wishedOutdoorFloor = 'Aucun'
            this.appart.wishedOutdoorGround = 'Aucun'
        }
    }

    @Watch('appart', { deep: true, immediate: true })
    onAppart() {
        this.appart.wishedOutdoorGround = this.appart.wishedOutdoorFloor
    }

    tooltips = {        brs: `
            <div class="text-left">
                <p><strong>Êtes-vous éligible au Bail Réel Solidaire (BRS) à Montpellier ?</strong></p>
                <p>Le BRS permet d'acheter votre résidence principale à un prix inférieur au marché.<br>
                Vous êtes propriétaire de votre logement, mais le terrain appartient à un Organisme de Foncier Solidaire (OFS), ce qui réduit le prix d'achat.</p>
                <p>Pour être éligible à Montpellier (zone A), votre revenu fiscal de référence (N-2) ne doit pas dépasser :</p>
                <ul style="list-style: none; padding-left: 0;">
                    <li>1 personne : xx xxx €</li>
                    <li>2 personnes : xx xxx €</li>
                    <li>3 personnes : xx xxx €</li>
                    <li>4 personnes : xx xxx €</li>
                    <li>5 personnes : xx xxx €</li>
                    <li>6 personnes : xx xxx €</li>
                    <li>(+ environ xx xxx € par personne supplémentaire)</li>
                </ul>
                <p>Pour des raisons d'équité et d'adéquation entre la taille du logement et la composition du foyer, les typologies sont généralement réparties ainsi :</p>
                <ul style="list-style: none; padding-left: 0;">
                    <li><strong>T2</strong> : principalement destinés aux personnes seules ou aux couples</li>
                    <li><strong>T3</strong> : adaptés aux couples ou aux foyers avec 1 enfant</li>
                    <li><strong>T4 / T5</strong> : prioritairement réservés aux familles</li>
                </ul>
                <p>L'attribution définitive est validée par l'OFS en commission, après étude complète de votre dossier.</p>
                <p><em>Si vous avez le moindre doute sur votre éligibilité, notre équipe est à votre disposition pour vous renseigner.<br>
                Merci de vérifier votre situation avant de poursuivre votre inscription.</em></p>
            </div>
        `,
        brsSurfaces: `
            <div class="text-left">
                <p><strong>ATTENTION: Limites de surface pour les logements BRS</strong></p>
                <p>En achetant votre logement en accession abordable sous le régime du BRS, vous devez respecter un cadre réglementaire qui limite les surfaces par typologie.</p>
                <p><strong>La surface habitable de votre logement doit être comprise entre :</strong></p>
                <ul style="list-style: none; padding-left: 0;">
                    <li>• <strong>T2</strong> : entre 40 m² et 50 m²</li>
                    <li>• <strong>T3</strong> : entre 55 m² et 70 m²</li>
                    <li>• <strong>T4</strong> : entre 80 m² et 95 m²</li>
                    <li>• <strong>T5</strong> : entre 95 m² et 110 m²</li>
                </ul>
                <p><em>Ces limites réglementaires sont obligatoires et ne peuvent pas être dépassées dans le cadre du dispositif BRS.</em></p>
            </div>
        `,
        brsParking: `
            <div class="text-left">
                <p><strong>Stationnement inclus en BRS</strong></p>
                <p>Les logements BRS sont toujours livrés avec <strong>1 place de stationnement comprise dans le prix</strong> de votre logement.</p>
                <p><strong>ATTENTION :</strong> Le prix du parking n'est pas ajouté au prix du logement. Cette place de stationnement est déjà incluse dans le prix global.</p>
                <p><em>Vous n'avez pas à faire de choix concernant le stationnement pour les logements BRS.</em></p>
            </div>
        `,
        surface: `
            <div>Petit nid douillet ou volumes plus généreux ?</div>
            <div>
                La surface habitable indiquée concerne uniquement l’appartement et ne comprend pas les extérieurs, le
                stationnement ou les espaces partagés.
            </div>
            <div>
                Cette surface sera susceptible de varier lors de l’élaboration des plans de réservation par l’architecte, à l’issu de
                la programmation sur la plateforme Yvivre.
            </div>
        `,
        budget: `
            <div>Respecter votre budget, c’est la base ! Dites-nous le montant maximum à ne pas dépasser.</div>
            <div>Le prix tient compte de la totalité de votre projet : logement + espaces partagés + stationnement.</div>
            <div>Les frais de notaire ne sont pas compris.</div>padd
        `,
        floors: `
            <div>Plus l’étage est élevé, plus vous bénéficierez d’un bon ensoleillement.</div>
            <div>Les étages les plus élevés impliquent un coût plus important.</div>
        `,
        exposition: `
            <p>Votre logement profitera d’un ensoleillement différent en fonction de son exposition</p>
            <p>
                <b>Meilleur prix</b>
                <ul>
                    <li>Nord : moins de lumière mais plus de fraicheur en été</li>
                    <li>Est : une belle lumière toute la matinée, ambiance plus tamisée le soir</li>
                </ul>
            </p>
            <p>
                <b>Coût plus élevé</b>
                <ul>
                    <li>Ouest : du soleil tout l’après-midi et jusqu’à la tombée de la nuit</li>
                    <li>Sud : un maximum de luminosité toute la journée et plus de chaleur</li>
                </ul>
            </p>
        `,
        outdoorSpaces: `
            <div>Il s'agira d'une terrasse si vous vous situez en étage et d'un jardin si vous êtes en rez-de-chaussée.</div>
        `,
        parking: `
            De combien de places de stationnement avez-vous besoin ? Le prix d’une place varie de 15000 à 30000€
        `,
        description: `
            Un meuble de famille qui doit rentrer dans le salon, un piano de grande dimension, un mur pour votre rétroprojecteur, un besoin spécifique en terme d'espace ou de volume … c'est l'endroit où nous en faire part, afin qu'on vous aide à créer le logement qui vous corresponde au mieux !
        `,
    }

    /**
     * Binding de floor
     */
    setFloor(appart) {
        this.floor.items[0].active = appart.wishedFloors.ground
        this.floor.items[1].active = appart.wishedFloors.r1 || false
        this.floor.items[2].active = appart.wishedFloors.intermediate
        this.floor.items[3].active = appart.wishedFloors.intermediateSupp || false
        this.floor.items[4].active = appart.wishedFloors.top
        //this.floor.items[5].active = appart.wishedFloors.house
    }

    /**
     * Toggle pour les étages (remplace le composant Choices)
     */
    toggleFloor(item) {
        if (this.floor.multiple) {
            item.active = !item.active
        } else {
            this.floor.items.forEach(i => i.active = false)
            item.active = true
        }
    }

    /**
     * Toggle pour les espaces extérieurs (remplace le composant Choices)
     */
    toggleOutdoor(item) {
        if (this.outdoor.multiple) {
            item.active = !item.active
        } else {
            this.outdoor.items.forEach(i => i.active = false)
            item.active = true
        }
    }

    /**
     * Toggle pour le parking
     */
    toggleParking(item) {
        this.appart.wishedParking = item.value
    }

    @Watch('cleanFloor')
    onCleanFloor(val, oldVal) {
        this.appart.wishedFloors = val
    }

    get cleanFloor() {
        const floor = {
            ground: this.floor.items[0].active,
            r1: this.floor.items[1].active,
            soho: false, // Conservé pour compatibilité backend
            intermediate: this.floor.items[2].active,
            intermediateSupp: this.floor.items[3].active,
            top: this.floor.items[4].active,
            house: false, // Conservé pour compatibilité backend
        }
        return floor
    }

    /**
     * Binding de exposure
     */
    setExposure(appart) {
        this.exposure.items[0].active = appart.wishedExposures.north
        this.exposure.items[1].active = appart.wishedExposures.east
        this.exposure.items[2].active = appart.wishedExposures.west
        this.exposure.items[3].active = appart.wishedExposures.south
    }

    @Watch('cleanExposure')
    onCleanExposure(val, oldVal) {
        this.appart.wishedExposures = val
    }

    get cleanExposure() {
        const exposure = {
            north: this.exposure.items[0].active,
            east: this.exposure.items[1].active,
            west: this.exposure.items[2].active,
            south: this.exposure.items[3].active,
        }
        return exposure
    }

    /**
     * Binding de outdoor - gère plusieurs espaces extérieurs
     */
    setOutdoor(appart) {
        // Réinitialiser tous les items
        this.outdoor.items.forEach(item => item.active = false)

        // Si wishedOutdoorSurfaces existe et contient des valeurs
        if (appart.wishedOutdoorSurfaces && appart.wishedOutdoorSurfaces.length > 0) {
            appart.wishedOutdoorSurfaces.forEach(surface => {
                const item = this.outdoor.items.find(i => i.surface === surface)
                if (item) {
                    item.active = true
                }
            })
        } else if (!isNaN(appart.wishedOutdoorFloor)) {
            // Compatibilité avec l'ancien système (une seule surface)
            const item = this.outdoor.items.find(i => i.surface === appart.wishedOutdoorFloor)
            if (item) {
                item.active = true
            }
        } else if (appart.wishedOutdoorFloor == 'Aucun') {
            this.outdoor.items[0].active = true
        }
    }


    /**
     * Binding de parking
     */
    setParking(appart) {
        // wishedParking est maintenant un INT, pas besoin de switch
        // La propriété calculée parkingItems gère l'état active automatiquement
    }
    
    @Watch('cleanParking')
    onCleanParking(val, oldVal) {
        this.appart.wishedParking = val
    }
    
    get cleanParking() {
        return this.appart.wishedParking
    }

    /**
     * Watcher pour désactiver les étages non autorisés en BRS
     */
    @Watch('appart.eligibleBRS')
    onBRSChange(isBRS: boolean) {
        if (isBRS) {
            // Désactiver les étages non autorisés en BRS (étages 3 et 4)
            if (this.floor.items[3]) this.floor.items[3].active = false  // Étages intermédiaires supp.
            if (this.floor.items[4]) this.floor.items[4].active = false  // Dernier niveau
            
            // Désactiver les espaces extérieurs non autorisés en BRS (indices 4 et 5)
            if (this.outdoor.items[4]) this.outdoor.items[4].active = false  // Grand (20 m²)
            if (this.outdoor.items[5]) this.outdoor.items[5].active = false  // Très grand (25 m²)
            
            // Définir automatiquement le stationnement à 1 place pour BRS
            this.appart.wishedParking = 1
            
            // Mettre à jour la liste filtrée
            this.updateFilteredFloor()
        } else {
            // Quand BRS est décoché, réinitialiser la typologie à null
            this.appart.typologieBRS = null
            
            // Rétablir tous les étages
            this.updateFilteredFloor()
        }
    }

    /**
     * Propriété computed pour les étages visibles
     */
    get visibleFloorItems() {
        if (this.appart.eligibleBRS) {
            // Pour BRS, ne montrer que les 3 premiers étages
            return this.floor.items.slice(0, 3)
        }
        return this.floor.items
    }

    /**
     * Propriété computed pour les espaces extérieurs visibles
     */
    get visibleOutdoorItems() {
        if (this.appart.eligibleBRS) {
            // Pour BRS, ne montrer que les 4 premiers espaces extérieurs (Aucun, Mini, Petit, Intermédiaire)
            return this.outdoor.items.slice(0, 4)
        }
        return this.outdoor.items
    }

    /**
     * Méthode pour mettre à jour les étages filtrés
     */
    updateFilteredFloor() {
        if (this.appart.eligibleBRS) {
            // Pour BRS, ne montrer que les 3 premiers étages
            this.filteredFloorItems = [
                this.floor.items[0],
                this.floor.items[1],
                this.floor.items[2]
            ]
        } else {
            // Montrer tous les étages
            this.filteredFloorItems = [...this.floor.items]
        }
    }

    /**
     * Propriété calculée pour filtrer les étages disponibles selon BRS
     */
    get filteredFloor() {
        return {
            multiple: this.floor.multiple,
            items: this.filteredFloorItems || this.floor.items
        }
    }

    /**
     * Champs
     */
    floor = {
        multiple: true,
        items: [
            {
                img: 'logement-etage-rdc.png',
                title: 'Rez-de-chaussée',
                //subtitle: 'Très économique',
                active: false,
            },
            {
                img: 'logement-etage-premier.png',
                title: 'R+1',
                //subtitle: 'Économique',
                active: false,
            },
            /*{
                img: 'logement-soho.png',
                title: 'Duplex SOHO',
                //subtitle: 'Économique',
                help:
                    'Le SOHO est une combinaison qui comprend un espace de travail au RDC avec accès sur la rue (convient aux professions libérales, freelance, petits commerces, ...) et le logement en lien avec le local se situe au dessus en R+1',
                active: false,
            },*/
            {
                img: 'logement-etage-intermediaire.png',
                title: 'Étage intermédiaire',
                //subtitle: 'Modéré',
                active: false,
            },
            {
                img: 'logement-etage-intermediaire-supp.png',
                title: 'Étages intermédiaires supp.',
                //subtitle: 'Modéré',
                active: false,
            },
            {
                img: 'logement-etage-haut.png',
                title: 'Dernier niveau',
                //subtitle: 'Plus onéreux',
                active: false,
            },
            /*{
                img: 'logement-maison.png',
                title: 'Maison de ville',
                help:
                    "Il s'agit de maisons mitoyennes traversantes sur 2 niveaux avec jardin au RDC. Merci de préciser plus bas la surface de m² souhaitée pour cet espace extérieur de jardin",
                active: false,
            },*/
        ],
    }

    exposure = {
        multiple: true,
        items: [
            {
                img: 'logement-nord.png',
                title: 'Nord',
                subtitle: 'Très économique',
                active: false,
            },
            {
                img: 'logement-est.png',
                title: 'Est',
                subtitle: 'Économique',
                active: false,
            },
            {
                img: 'logement-ouest.png',
                title: 'Ouest',
                subtitle: 'Modéré',
                active: false,
            },
            {
                img: 'logement-sud.png',
                title: 'Sud',
                subtitle: 'Plus onéreux',
                active: false,
            },
        ],
    }

    outdoor = {
        multiple: true,
        items: [
            {
                img: 'logement-espace-exterieur-sans.png',
                title: 'Aucun',
                subtitle: null,
                active: false,
            },
            {
                img: 'logement-espace-exterieur-mini.png',
                title: 'Mini (5 m²)',
                subtitle: null,
                active: false,
                surface: 5,
            },
            {
                img: 'logement-espace-exterieur-petit.png',
                subtitle: null,
                title: 'Petit (10 m²)',
                active: false,
                surface: 10,
            },
            {
                img: 'logement-espace-exterieur-intermediaire.png',
                subtitle: null,
                title: 'Intermédiaire (15 m²)',
                active: false,
                surface: 15,
            },
            {
                img: 'logement-espace-exterieur-grand.png',
                subtitle: null,
                title: 'Grand (20 m²)',
                active: false,
                surface: 20,
            },
            {
                img: 'logement-espace-exterieur-tres-grand.png',
                subtitle: null,
                active: false,
                title: 'Très grand (25 m²)',
                surface: 25,
            }, 
        ],
    }

    /**
     * Propriété calculée pour générer dynamiquement les options de parking
     */
    get parkingItems() {
        const maxParking = this.operation && this.operation.maxWishedParking ? this.operation.maxWishedParking : 2
        const items = []
        
        for (let i = 0; i <= maxParking; i++) {
            items.push({
                title: i === 0 ? 'Aucun' : `${i} place${i > 1 ? 's' : ''}`,
                value: i,
                active: this.appart.wishedParking === i
            })
        }
        
        return items
    }

    get parking() {
        return {
            multiple: false,
            items: this.parkingItems
        }
    }

    /**
     * Utilisé pour savoir si la surface totale est supérieure à la surface
     * souhaitée
     */
    isSurfaceOk = true
    surfaceTotale: number = 0

    id: number = null
    opeID: number = null
    operation = null

    async created() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.id = UserModule.userInfos.id
        this.opeID = await getOperationID()

        // Initialiser les étages filtrés
        this.updateFilteredFloor()

        /**
         * Récupération de l'UserOperation
         */
        this.apiService.getUserOperation(this.id, this.opeID).then(resp => {
            const userOperation = resp.data

            /**
             * Récupération des infos de l'appartement
             */
            const wishedSurface = parseInt(userOperation.wishedSurface, 10)
            this.appart = {
                ...this.appart,
                wishedSurface: !isNaN(wishedSurface) ? wishedSurface : null,
                maxFund: userOperation.maxFund || 0,
                wishedParking: parseInt(userOperation.wishedParking, 10) || null,
                wishedParkingBoxed: userOperation.wishedParkingBoxed == 1,
                eligibleBRS: userOperation.brs == 1 || userOperation.brs === true,  // Lecture depuis la colonne 'brs'
                typologieBRS: userOperation.typologie || null,  // Lecture depuis la colonne 'typologie'
                comment: userOperation.comment || '',
                commentKitchen: userOperation.commentKitchen || '',
                commentBathroom: userOperation.commentBathroom || '',
                wishedOutdoorFloor: userOperation.wishedOutdoorFloor || null,
                wishedOutdoorGround: userOperation.wishedOutdoorGround || null,
                wishedOutdoorSurfaces: userOperation.wishedOutdoorSurfaces || [],
                wishedFloors: {
                    ...this.appart.wishedFloors,
                    ...userOperation.wishedFloors,
                },
                wishedExposures: {
                    ...this.appart.wishedExposures,
                    ...userOperation.wishedExposures,
                },
                userOperationRooms: this.parseRooms(
                    userOperation.userOperationRooms
                ),
            }

            /**
             * Initialisation des champs
             */
            this.setFloor(this.appart)
            this.setExposure(this.appart)
            this.setOutdoor(this.appart)
            this.setParking(this.appart)
            
            // Mettre à jour les étages filtrés après avoir chargé les données
            this.updateFilteredFloor()
        })

        /**
         * Récupération de la définition de l'opétation
         */
        const opSlug = getOperation()

        const allOpReq = await this.apiService.getAllOpe().then(allOpReq => {
            const allOp = allOpReq.data
            const op = allOp.find(el => {
                return el.slug === opSlug
            })
            console.log(op)
            this.operation = op
        })
    }

    mounted() {
        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })

        const $modal = $(this.$refs.modal) as any
        $modal.on('hidden.bs.modal', this.onModalHidden)
    }

    destroyed() {
        const $modal = $(this.$refs.modal) as any
        $modal.on('hidden.bs.modal', this.onModalHidden)
    }

    get brsSurfaceLimits(): { min: number | null, max: number | null } {
        if (!this.appart.eligibleBRS || !this.appart.typologieBRS) {
            return { min: null, max: null }
        }
        
        const limits = {
            'T2': { min: 40, max: 50 },
            'T3': { min: 55, max: 70 },
            'T4': { min: 80, max: 95 },
            'T5': { min: 95, max: 110 }
        }
        
        return limits[this.appart.typologieBRS] || { min: null, max: null }
    }

    get isSurfaceInBRSLimits(): boolean {
        if (!this.appart.eligibleBRS || !this.appart.typologieBRS || !this.appart.wishedSurface) {
            return true // Pas de contrainte si BRS n'est pas coché ou typologie pas sélectionnée
        }
        
        const { min, max } = this.brsSurfaceLimits
        if (min === null || max === null) return true
        
        return this.appart.wishedSurface >= min && this.appart.wishedSurface <= max
    }

    get wishedSurfaceValid(): boolean {
        const basicValid = (
            this.appart.wishedSurface !== null &&
            this.appart.wishedSurface.toString().trim() !== '' &&
            this.appart.wishedSurface >= 0
        )
        
        // Si BRS est coché, vérifier aussi les limites
        if (this.appart.eligibleBRS && this.appart.typologieBRS) {
            return basicValid && this.isSurfaceInBRSLimits
        }
        
        return basicValid
    }

    get wishedFloorsValid(): boolean {
        return (
            this.appart.wishedFloors.ground ||
            this.appart.wishedFloors.r1 ||
            this.appart.wishedFloors.intermediate ||
            this.appart.wishedFloors.intermediateSupp ||
            this.appart.wishedFloors.soho ||
            this.appart.wishedFloors.top ||
            this.appart.wishedFloors.house
        )
    }

    get wishedExposureValid(): boolean {
        return (
            this.appart.wishedExposures.north ||
            this.appart.wishedExposures.south ||
            this.appart.wishedExposures.east ||
            this.appart.wishedExposures.west
        )
    }

    get wishedOutdoorValid(): boolean {
        // Valide si au moins un espace extérieur est sélectionné ou si "Aucun" est choisi
        return (
            (this.appart.wishedOutdoorSurfaces && this.appart.wishedOutdoorSurfaces.length > 0) ||
            this.outdoor.items[0].active
        )
    }

    get wishedParkingValid(): boolean {
        // Pour BRS, le stationnement est automatiquement à 1 place
        if (this.appart.eligibleBRS) {
            return true
        }
        return this.appart.wishedParking !== null
    }

    get typologieBRSValid(): boolean {
        // La typologie est valide si BRS n'est pas coché, ou si elle est cochée et qu'une typologie est sélectionnée
        return !this.appart.eligibleBRS || (this.appart.eligibleBRS && this.appart.typologieBRS !== null && this.appart.typologieBRS !== '')
    }

    get appartValid(): boolean {
        return (
            this.wishedSurfaceValid &&
            this.wishedFloorsValid &&
            this.wishedExposureValid &&
            this.wishedOutdoorValid &&
            this.wishedParkingValid &&
            this.typologieBRSValid
        )
    }

    get hasParking() {
        return this.parking.items[1].active //|| this.parking.items[2].active
    }

    async handleSubmit(e) {
        e.preventDefault()

        // Créer une copie de appart sans eligibleBRS et typologieBRS
        const { eligibleBRS, typologieBRS, ...appartData } = this.appart

        const req = {
            ...appartData,
            wishedOutdoorFloor: this.appart.wishedOutdoorFloor,
            wishedOutdoorGround: this.appart.wishedOutdoorGround,
            wishedOutdoorSurfaces: this.appart.wishedOutdoorSurfaces,
            wishedParkingBoxed: 0, //this.appart.wishedParkingBoxed ? 1 : 0,
            brs: this.appart.eligibleBRS,  // Envoyer le booléen directement
            typologie: this.appart.eligibleBRS ? (this.appart.typologieBRS || null) : null,  // Null si BRS décoché
        }

        const isRoomsOk = this.surfaceTotale > 0 ? this.isSurfaceOk : true

        if (!this.appartValid || !isRoomsOk) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                'La configuration de votre appartement est incomplète'
            )
            this.submitted = true
            return
        }

        this.submitted = false

        try {
            // set Favori à null
            // await this.apiService.patchSaveFavorite(this.id, this.opeID, {
            //     favorite: '{}',
            // })

            const resp = await this.apiService.patchUserOperation(
                this.id,
                this.opeID,
                req
            )
            // console.log(resp)
            // ;(<Alert>this.$refs.alert).handleAlert(
            //     'success',
            //     'Enregistrement effectué'
            // )
        } catch (e) {
            ;(<Alert>this.$refs.alert).handleAlert('danger', e.message)
        }

        const $project = this.$refs.project as Project
        await $project.resresh()

        const $modal = $(this.$refs.modal) as any
        $modal.modal('show')
    }

    async onModalClose() {
        const $modal = $(this.$refs.modal) as any
        $modal.modal('hide')
    }

    onModalHidden() {
        const $project = this.$refs.project as Project
        if ($project) {
            $project.reset()
        }
    }

    parseRooms(pRooms): IRoom[] {
        var rooms: IRoom[] = []
        pRooms.forEach(el => {
            const room: IRoom = {
                room: el.room.id,
                quantity: el.quantity,
                size: el.size || null,
                options: el.options || [],
            }
            rooms.push(room)
        })
        return rooms
    }
}
